import React, { FC, useEffect, useState } from "react";
import { Button, DatePicker, Form, Select, Tabs } from "antd";
import moment from "moment";
import CryptoCorrelationsTable from "./CryptoCorrelationsTable";
import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import { formItemLayout } from "../../services/constants";
import { CorrelationBases, RollingCorrelationPeriods, RollingCorrelationPeriodsArray } from "../../services/enums";
import { ILayoutRibbon } from "../../models/layout-ribbon.model";
import { IResultResponse } from "../../models/response/result.model";

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

const CryptoCorrelations: FC = () => {
  const [form] = Form.useForm();

  const [correlationSettings, setCorrelationSettings] = useState<any>({
    correlationBasis: CorrelationBases.Daily,
    updateTrigger: 0
  });

  const { fetchedData: instruments, loading: instrumentsLoading } = useHttpGet<
    IResultResponse<ILayoutRibbon[]>
  >(`${APIRoutes.LAYOUT_RIBBON}`, {
    defaultValue: {
      result: [] as ILayoutRibbon[],
    },
  });

  const handleSubmitForm = async (values: any) => {
    setCorrelationSettings({
      ...values,
      startDate: values.dates && moment(values.dates[0]).format('yyyy-MM-DD'),
      endDate: values.dates && moment(values.dates[1]).format('yyyy-MM-DD'),
      updateTrigger: new Date().getMilliseconds()
    });
  };

  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Daily" key="1">
        <CryptoCorrelationsTable
          correlationSettings={{
            correlationBasis: CorrelationBases.Daily,
            startDate: moment().add(-1, 'y').format('yyyy-MM-DD'),
            endDate: moment().format('yyyy-MM-DD'),
          }}
        />
      </TabPane>

      <TabPane tab="Monthly" key="2">
        <CryptoCorrelationsTable
          correlationSettings={{
            correlationBasis: CorrelationBases.Monthly,
            startDate: moment().add(-1, 'y').format('yyyy-MM-DD'),
            endDate: moment().format('yyyy-MM-DD'),
          }}
        />
      </TabPane>

      <TabPane tab="Custom" key="3">
        <Form
          {...formItemLayout}
          form={form}
          hideRequiredMark={false}
          onFinish={handleSubmitForm}
        >
          <Form.Item
            label="Instruments"
            name="instrumentIds"
            rules={[{ required: true, message: "Please select at least 2 instruments" }]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Please select at least 2 instruments"
            >
              {instruments?.result?.filter(f => !!f.idInstrument).map((el: ILayoutRibbon) => (
                <Select.Option key={el.idInstrument} value={el.idInstrument}>
                  {el.name}({el.ticker})
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Dates"
            name="dates"
          >
            <RangePicker />
          </Form.Item>

          <Form.Item
            label="Correlation Basis"
            name="correlationBasis"
          >
            <Select
              style={{ minWidth: "15em" }}
            >
              <Select.Option key={CorrelationBases.Daily} value={CorrelationBases.Daily}>Daily</Select.Option>
              <Select.Option key={CorrelationBases.Monthly} value={CorrelationBases.Monthly}>Monthly</Select.Option>
              <Select.Option key={CorrelationBases.Annual} value={CorrelationBases.Annual}>Annual</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 5, span: 19 }}>
            <Button type="primary" htmlType="submit">
              Run
            </Button>
          </Form.Item>
        </Form>

        <CryptoCorrelationsTable correlationSettings={correlationSettings} />
      </TabPane>
    </Tabs>
  );
};

export default CryptoCorrelations;
